import { enableMapSet } from 'immer';
import { enableTransmute } from 'immutable-less/transmute-compatibility';
import App from 'automation-ui-canvas/App';
enableMapSet();
enableTransmute();
new App().start();